import type { Specifiers } from 'markets-store/types'
import { PERIOD_SPECIFIERS } from 'markets-store/constants'

const PERIOD_VARIABLES_NAMES = new Set(PERIOD_SPECIFIERS)

export function hasPeriod(specifiers: Specifiers | undefined) {
  if (!specifiers) return ''
  return Object.keys(specifiers).find((sp) => PERIOD_VARIABLES_NAMES.has(sp))
}
